import React, {useState, useEffect} from "react";
import {Form, Col, Input, Card, Collapse, Button, Popover} from 'antd';
import jsonfile from './userchange.json';
import {useHistory} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "../../../../util/IntlMessages";
import Config from "../../../../util/config";
import axiosinstance from "../../../../util/Api";
import CircularProgress from "../../../../components/CircularProgress";
const Panel = Collapse.Panel;

const UserChangeLog = () => {
    const [loader, setLoader] = useState(false);
    const [apiData, setAPIData] = useState([]);
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.list,
        filtervalue : '',
        subtitle:''
    });
    useEffect(() => {
        setLoader(true)
        axiosinstance.get(state.reqURL)
            .then(res => {
                if(res.data.status === 1){
                    setAPIData(res.data.data)
                    CisUI().createNotification('error', res.data.msg)
                }
                else{
                    CisUI().createNotification('error', res.data.msg)
                }
                setLoader(false)
            })
            .catch(error => {
                console.log(error)
                setLoader(false)
            })
    }, [state.reqURL]);

    const history = useHistory();

    const HandleJsonData = (data) => {
        let newData = JSON.parse(data);
        return (
            <div>
                {Object.entries(newData).map(([key, value]) => (
                    <p key={key}>{key}: {value}</p>
                ))}
            </div>
        );
    }


    const headers = {
        id: {
            text: <IntlMessages id="Sl NO"/>,
            sortable: true,
            filterable: true,
        },
        data_table: {
            text: <IntlMessages id="Table"/>,
            sortable: true,
            filterable: true,
        },
        rowid: {
            text: <IntlMessages id="Row ID"/>,
            sortable: true,
            filterable: true,
        },
        time: {
            text: <IntlMessages id="Time"/>,
            sortable: true,
            filterable: true,
            transform: (value) => (
                CisUI().DateFormatWithTime(value)
            )
        },
        changed_by: {
            text: <IntlMessages id="Changed By"/>,
            sortable: true,
            filterable: true,
        },
        new_data: {
            text: <IntlMessages id="Changed Data"/>,
            sortable: true,
            filterable: true,
            // invisible: true,
            transform: (value, idx, row) => (
                // <Button className="btn btn-sm" onClick={() => HandleNewData(value)}>See More</Button>
                <Popover content={() => HandleJsonData(value)} title="Changed Data">
                    <Button className="btn btn-sm">See More</Button>
                </Popover>
            )
        },
        old_data: {
            text: <IntlMessages id="Old Data"/>,
            sortable: true,
            style: "white-space: wrap",
            filterable: true,
            // invisible: true,
            transform: (value, idx, row) => (
                <Popover content={() => HandleJsonData(value)} title="Old Data">
                    <Button className="btn btn-sm">See More</Button>
                </Popover>
            )
        },
        status: {
            text: <IntlMessages id="Status"/>,
            sortable: true,
            filterable: true,
            invisible: true,
            transform: (value, idx, row) => (
                CisUI().getStatusLabel(value)
            )
        },
        // details: {
        //     text: <IntlMessages id="Details"/>,
        //     sortable: true,
        //     filterable: true,
        //     transform: (value, idx, row) => (
        //             <>
        //             <Button className="btn btn-sm">Changed Data</Button>
        //             <Button className="btn btn-sm">Old Data</Button>
        //             </>
        //     )
        // }
    };

    const orderedHeaders = jsonfile.listView.title;

    const [form] = Form.useForm();

    const onFinish = values => {
        // console.log('Received values of form: ', values);
        const qs = Object.keys(values).map(key => `${key}=${values[key]}`).join('&');
        const qsup = qs.replaceAll("undefined","");
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.list+"/?"+qsup;
        setState({reqURL: newURL});
    };


    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header={<IntlMessages id="Advance Search"/>} key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.userChangeLog)}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = CisUI().ListActionButtonV2("../"+jsonfile.urls.add, "", state.reqURL, jsonfile);

    if(loader){
        return <CircularProgress />;
    }

    return (
        <>
            {searchView}
            <Card title={<IntlMessages id={jsonfile.listtitle}/>} extra={getExtra}>

                <SmartDataTable
                    name='test-fake-table'
                    data={apiData}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={state.filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    withHeader
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />
            </Card>
        </>
    );
};

export default UserChangeLog;